(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-alt"] && !Shopify.designMode) return;
  try {
    
(function() {
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // 100vw includes the scrollbar; innerWidth minus documentElement.clientWidth
  // is its actual width. Published as a CSS var so the full-bleed margins can
  // subtract it and land exactly on the viewport edges.
  var syncScrollbarVar = function() {
    var width = window.innerWidth - document.documentElement.clientWidth;
    if (!(width > 0)) { width = 0; }
    document.documentElement.style.setProperty("--rp-alt-scrollbar", width + "px");
  };

  syncScrollbarVar();
  window.addEventListener("resize", syncScrollbarVar);

  // --- carousel ------------------------------------------------------------
  var initRelatedCarouselAlt = function(root) {
    var wrap = root.querySelector("[data-rp-alt]");
    var track = root.querySelector("[data-rp-alt-track]");
    if (!wrap || !track || !track.children.length) { return; }

    var prev = root.querySelector("[data-rp-alt-prev]");
    var next = root.querySelector("[data-rp-alt-next]");
    var dotsWrap = root.querySelector("[data-rp-alt-dots]");
    if (!prev || !next || !dotsWrap) { return; }

    var pages = [0]; // slide index each dot jumps to

    var scrollable = function() {
      return track.scrollWidth - track.clientWidth > 2;
    };

    // Free-flow drag: no snapping, so a release coasts to a stop instead.
    // Touch already gets this natively; this covers desktop mouse drag.
    var momentumRaf = null;
    var velocity = 0; // px per ms, positive scrolls right

    var cancelMomentum = function() {
      if (momentumRaf !== null) {
        window.cancelAnimationFrame(momentumRaf);
        momentumRaf = null;
      }
    };

    var startMomentum = function() {
      cancelMomentum();

      var v = velocity * 16; // px per frame at ~60fps
      var MAX = 60;
      if (v > MAX) { v = MAX; }
      if (v < -MAX) { v = -MAX; }
      if (Math.abs(v) < 0.5) { return; }

      var step = function() {
        v *= 0.94; // friction
        if (Math.abs(v) < 0.2) { momentumRaf = null; return; }

        var before = track.scrollLeft;
        track.scrollLeft = before + v;

        // Stop dead at either end rather than spinning out the decay.
        if (Math.abs(track.scrollLeft - before) < 0.5) { momentumRaf = null; return; }

        momentumRaf = window.requestAnimationFrame(step);
      };

      momentumRaf = window.requestAnimationFrame(step);
    };

    var scrollTo = function(left) {
      cancelMomentum();
      if (reduceMotion) {
        track.scrollLeft = left;
      } else {
        track.scrollTo({ left: left, behavior: "smooth" });
      }
    };

    // --- slide geometry ----------------------------------------------------
    // Snapping is done in JS rather than with CSS scroll-snap, because the CSS
    // property would also snap free drags. Arrows and dots scroll to exact
    // slide offsets; dragging stays unconstrained.

    // Horizontal padding on the track (non-zero when full bleed is on).
    var trackPadding = function() {
      var cs = window.getComputedStyle(track);
      return {
        left: parseFloat(cs.paddingLeft) || 0,
        right: parseFloat(cs.paddingRight) || 0
      };
    };

    // Width slides are actually laid out across. Equals clientWidth when the
    // track isn't padded, so the contained and full-bleed cases share a path.
    var contentWidth = function() {
      var pad = trackPadding();
      return track.clientWidth - pad.left - pad.right;
    };

    // Scroll positions that would bring each slide flush to the content edge.
    // Measured from the padding edge so offs[0] is 0, not the gutter width —
    // otherwise the first card would sit one gutter off after any dot or arrow.
    var slideOffsets = function() {
      var contentLeft = track.getBoundingClientRect().left + trackPadding().left;
      var sl = track.scrollLeft;
      var out = [];
      for (var i = 0; i < track.children.length; i++) {
        out.push(sl + (track.children[i].getBoundingClientRect().left - contentLeft));
      }
      return out;
    };

    // Whole slides visible at once — 4.5 per view advances by 4.
    var slidesPerPage = function() {
      if (track.children.length < 2) { return 1; }

      var offs = slideOffsets();
      var step = offs[1] - offs[0]; // slide width + gap
      if (step <= 0) { return 1; }

      var slideWidth = track.children[0].getBoundingClientRect().width;
      var gap = step - slideWidth;

      // n slides occupy n widths but only n-1 gaps, so add one gap back before
      // dividing — otherwise a trailing gap gets charged and n comes out short.
      return Math.max(1, Math.floor((contentWidth() + gap + 1) / step));
    };

    // Slide currently sitting closest to the left edge.
    var leadIndex = function() {
      var offs = slideOffsets();
      var sl = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < offs.length; i++) {
        var dist = Math.abs(offs[i] - sl);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    };

    // Slide index each page starts at. Trailing duplicates are dropped so the
    // final short page doesn't produce two dots that scroll to the same spot.
    var computePages = function() {
      var offs = slideOffsets();
      if (!offs.length) { return [0]; }

      var spp = slidesPerPage();
      var max = track.scrollWidth - track.clientWidth;
      var starts = [];
      var lastTarget = null;

      for (var i = 0; i < offs.length; i += spp) {
        var target = Math.min(Math.max(offs[i], 0), max);
        if (lastTarget !== null && Math.abs(target - lastTarget) < 2) { break; }
        starts.push(i);
        lastTarget = target;
      }

      return starts.length ? starts : [0];
    };

    var goToSlide = function(index) {
      var offs = slideOffsets();
      if (!offs.length) { return; }

      if (index < 0) { index = 0; }
      if (index > offs.length - 1) { index = offs.length - 1; }

      var max = track.scrollWidth - track.clientWidth;
      var target = offs[index];
      if (target > max) { target = max; }
      if (target < 0) { target = 0; }

      scrollTo(target);
    };

    var syncState = function() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;

      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;

      var active;
      if (x >= max - 2) {
        // Pinned to the end: always light the last dot, since the final page
        // is usually short and wouldn't round up to it.
        active = pages.length - 1;
      } else {
        // Whichever page starts nearest the slide currently at the left edge.
        var lead = leadIndex();
        var bestDist = Infinity;
        active = 0;
        for (var p = 0; p < pages.length; p++) {
          var dist = Math.abs(pages[p] - lead);
          if (dist < bestDist) { bestDist = dist; active = p; }
        }
      }

      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        var on = i === active;
        dots[i].classList.toggle("is-active", on);
        dots[i].setAttribute("aria-current", on ? "true" : "false");
      }
    };

    var buildDots = function() {
      dotsWrap.innerHTML = "";

      pages = computePages();
      if (pages.length < 2) { return; }

      for (var i = 0; i < pages.length; i++) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "rp-alt-dot";
        dot.setAttribute("aria-label", "Go to slide group " + (i + 1));
        (function(page) {
          dot.addEventListener("click", function() {
            goToSlide(pages[page]);
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    };

    var rebuild = function() {
      var canScroll = scrollable();
      // Toggled on .rp-alt, not on the heading row — the title always shows.
      wrap.classList.toggle("has-overflow", canScroll);
      track.classList.toggle("is-draggable", canScroll);
      buildDots();
      dotsWrap.classList.toggle("has-pages", pages.length > 1);
      syncState();
    };

    prev.addEventListener("click", function() { goToSlide(leadIndex() - slidesPerPage()); });
    next.addEventListener("click", function() { goToSlide(leadIndex() + slidesPerPage()); });

    // --- drag to scroll (desktop mouse only) -------------------------------
    // Touch and pen are left alone so native momentum scrolling still applies.
    var DRAG_THRESHOLD = 5; // px before a press counts as a drag rather than a click
    var dragging = false;
    var captured = false;
    var moved = false;
    var suppressClick = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var lastX = 0;
    var lastT = 0;

    var endDrag = function() {
      if (!dragging) { return; }
      dragging = false;

      if (captured && pointerId !== null) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      captured = false;
      pointerId = null;

      track.classList.remove("is-dragging");

      if (moved) {
        suppressClick = true;
        startMomentum();
      }
      moved = false;
    };

    track.addEventListener("pointerdown", function(event) {
      if (event.pointerType !== "mouse" || event.button !== 0) { return; }
      if (!scrollable()) { return; }

      cancelMomentum();

      dragging = true;
      moved = false;
      suppressClick = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;

      velocity = 0;
      lastX = event.clientX;
      lastT = window.performance ? window.performance.now() : Date.now();
    });

    track.addEventListener("pointermove", function(event) {
      if (!dragging || event.pointerId !== pointerId) { return; }

      var dx = event.clientX - startX;

      // Only take over once past the threshold, so plain clicks still reach
      // the product links underneath.
      if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        track.classList.add("is-dragging");
        try {
          track.setPointerCapture(pointerId);
          captured = true;
        } catch (err) {}
      }

      if (moved) {
        event.preventDefault();
        track.scrollLeft = startScroll - dx;

        var now = window.performance ? window.performance.now() : Date.now();
        var dt = now - lastT;
        if (dt > 0) {
          // Smoothed so one jittery frame before release doesn't set the throw.
          velocity = (velocity * 0.7) + (((lastX - event.clientX) / dt) * 0.3);
        }
        lastX = event.clientX;
        lastT = now;
      }
    });

    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    window.addEventListener("blur", endDrag);

    // Swallow the click that fires at the end of a drag gesture.
    track.addEventListener("click", function(event) {
      if (!suppressClick) { return; }
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    track.addEventListener("dragstart", function(event) { event.preventDefault(); });
    track.addEventListener("wheel", cancelMomentum, { passive: true });
    track.addEventListener("touchstart", cancelMomentum, { passive: true });

    var ticking = false;
    track.addEventListener("scroll", function() {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function() {
        syncState();
        ticking = false;
      });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener("resize", function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuild, 150);
    });

    // Images load after injection and change scrollWidth.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function() { rebuild(); });
      ro.observe(track);
    } else {
      window.addEventListener("load", rebuild);
    }

    rebuild();
  };

  // --- fetch ---------------------------------------------------------------
  var injectRelatedAlt = function(root, html) {
    var container = document.createElement("div");
    container.innerHTML = html;

    var fetched = container.querySelector(".related-products-alt");
    if (!fetched) { return false; }

    var fetchedTrack = fetched.querySelector("[data-rp-alt-track]");
    if (!fetchedTrack || !fetchedTrack.children.length) { return false; }

    root.innerHTML = fetched.innerHTML;
    initRelatedCarouselAlt(root);
    return true;
  };

  var loadRelatedProductsAlt = function(root) {
    if (!root) { return; }

    var tiers = (root.dataset.tiers || "").split(",");
    var urls = {
      complementary: root.dataset.urlComplementary,
      related: root.dataset.urlRelated
    };

    // Captured up front — the first successful tier replaces root's contents,
    // which would destroy the stashed template.
    var stash = root.querySelector("template[data-rp-alt-fallback]");
    var fallbackHTML = stash ? stash.innerHTML : "";

    var useCollectionFallback = function() {
      if (!fallbackHTML) { return false; }

      var probe = document.createElement("div");
      probe.innerHTML = fallbackHTML;
      var probeTrack = probe.querySelector("[data-rp-alt-track]");
      if (!probeTrack || !probeTrack.children.length) { return false; }

      root.innerHTML = fallbackHTML;
      initRelatedCarouselAlt(root);
      return true;
    };

    // Each tier either fills the section or hands off to the next one.
    var attempt = function(index) {
      if (index >= tiers.length) { return; }

      var tier = tiers[index];

      if (tier === "collection") {
        if (!useCollectionFallback()) { attempt(index + 1); }
        return;
      }

      var url = urls[tier];
      if (!url) { attempt(index + 1); return; }

      var request = new XMLHttpRequest();
      request.open("GET", url);
      request.onload = function() {
        var filled = request.status >= 200 &&
                     request.status < 300 &&
                     injectRelatedAlt(root, request.response);
        if (!filled) { attempt(index + 1); }
      };
      request.onerror = function() { attempt(index + 1); };
      request.send();
    };

    attempt(0);
  };

  var loadAllRelatedProductsAlt = function() {
    var sections = document.querySelectorAll(".related-products-alt");
    Array.prototype.forEach.call(sections, loadRelatedProductsAlt);
  };

  // Reload when the section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function(event) {
    var root = document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"].related-products-alt'
    );
    if (root) { loadRelatedProductsAlt(root); }
  });

  loadAllRelatedProductsAlt();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
